import AgreementPageNavigation from './AgreementPageNavigation.component';

export default AgreementPageNavigation;
